// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"f673492e","787":"a6ec645c","856":"d8ecd5e5","879":"9b752e3a"}[chunkId] + ".chunk.js";
};